import { createSlice } from '@reduxjs/toolkit';

const initialState = {};
export const valueAddsSlice = createSlice({
  name: 'valueAddDetails',
  initialState,
  reducers: {
    resetValueAddsSlice: (state) => initialState,
    addValueAdds: (state, action) => action.payload,
  },
});

// Action creators are generated for each case reducer function
export const { resetValueAddsSlice, addValueAdds } = valueAddsSlice.actions;

export default valueAddsSlice.reducer;
